import $ from 'jquery';
import MicroModal from 'micromodal';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger);

/**
 * Loop through forms and create them.
 *
 * @param {array} hbsptForms list of form items to initialize
 * @param {HTMLDivElement} formTrigger Singular button triggering form (modal)
 *
 * @return {undefined}
 */
export const loadHubspotForms = (hbsptForms, formTrigger = null) => {
  let modalForm = false;
  let forms = hbsptForms;

  if (formTrigger) {
    forms = [];
    forms.push(formTrigger);
    modalForm = true;
  }

  forms.forEach((form) => {
    let formId = $(form).data('form-id');
    let formLocation = $(form).data('form-location');
    // let formType = $(form).data('form-type');
    // let formAsset = $(form).data('form-asset');

    const hubspotConfig = {
      region: 'na1',
      portalId: '8314473',
      formId,
      target: modalForm
        ? '[data-modal-form-wrap]'
        : '#hbspot-form-' + formId + (formLocation ? '-' + formLocation : ''),
      onFormSubmitted: null
    };

    // eslint-disable-next-line
    hbspt.forms.create({
      ...hubspotConfig,
      onFormReady: function () {
        $('.hs-form h1').replaceWith(function () {
          return '<h2 class="text-1 no-margin">' + $(this).html() + '</h2>';
        });
        ScrollTrigger.refresh(true);
      },
      onFormSubmitted: function () {
        //  @Jacob I don't know what we want to happen on form submission so I'm commenting this out for now.
        /*
        if (formType === 'pdf') {
          $('.gated-resource__form-wrap').addClass('js-form-submitted');
          $('.gated-resource__form-success-message').show();

          window.open(formAsset, '_blank');
        } else if (formType === 'video') {
          window.location = `${window.location}?thank-you`;
        } */
      }
    });
  });
};

/**
 * Setup a button to open a modal that will show the desired form.
 *
 * @param {HTMLElement} button The button element that will trigger the modal
 *
 * @returns {*} no return
 */
export const setupModalForm = (button) => {
  const modalContainer = document.querySelector('[data-modal-container]');
  const formContent = modalContainer.querySelector('[data-modal-form-wrap]');

  const modalOptions = {
    onClose: (modal, element, event) => {
      event.preventDefault();
      event.stopPropagation();
      setTimeout(() => {
        formContent.style.display = 'none';
      }, 500);
    },
    disableScroll: true,
    awaitCloseAnimation: true,
    awaitOpenAnimation: true
  };

  const playPauseBtn = document.querySelector('[data-modal-play-pause-btn]');

  button.addEventListener('click', () => {
    loadHubspotForms(null, button);
    formContent.style.display = 'block';
    playPauseBtn.style.display = 'none';
    modalContainer.setAttribute(
      'aria-label',
      button.getAttribute('data-form-title') ?? 'Contact Form'
    );
    MicroModal.show('content-modal', modalOptions);
  });
};

export const hubspotInit = () => {
  let hbsptForms = document.querySelectorAll('[data-hubspot-form]');
  let hbsptFormTriggers = document.querySelectorAll(
    '[data-modal-form-trigger]'
  );

  /**
   * Load HubSpot scripts if required on current page and not already loaded.
   */
  if (hbsptForms.length > 0 || hbsptFormTriggers.length > 0) {
    if (typeof window.hbspt === 'undefined') {
      let loaded = 0;
      let hubspotScripts = [
        'https://js.hsforms.net/forms/v2-legacy.js',
        'https://js.hsforms.net/forms/v2.js'
      ];

      hubspotScripts.forEach((src) => {
        let script = document.createElement('script');
        script.type = 'text/javascript';
        script.src = src;
        script.onload = () => {
          loaded++;

          if (loaded === 2 && hbsptForms.length > 0) {
            loadHubspotForms(hbsptForms);
          }
        };
        document.head.appendChild(script);
      });
    }
  }

  hbsptFormTriggers.forEach((trigger) => {
    setupModalForm(trigger);
  });
};
